// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityAnnual {
    static getAttributeTypeMap() {
        return MedicalEligibilityAnnual.attributeTypeMap;
    }
}
MedicalEligibilityAnnual.discriminator = undefined;
MedicalEligibilityAnnual.additionalProperties = false;
MedicalEligibilityAnnual.attributeTypeMap = [
    {
        "name": "benefitCap",
        "baseName": "benefitCap",
        "type": "string"
    },
    {
        "name": "benefitCapMetAmount",
        "baseName": "benefitCapMetAmount",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityAnnual.js.map